<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  label: { type: String, default: '' },
  description: { type: String, default: '' },
});

const emit = defineEmits(['change']);

const { t } = useI18n();

const modelValue = defineModel({
  type: Boolean,
  default: false,
});

const updateValue = () => {
  modelValue.value = !modelValue.value;
  emit('change', !modelValue.value);
};
</script>

<template>
  <div class="flex items-center gap-3">
    <button
      type="button"
      class="group relative h-[18px] rounded-full w-8 flex-shrink-0 select-none focus:outline-none focus:ring-1 focus:ring-n-brand focus:ring-offset-n-slate-2 focus:ring-offset-2 transition-colors duration-200 ease-in-out"
      :class="modelValue ? 'bg-n-brand' : 'bg-n-slate-6'"
      role="switch"
      :aria-checked="modelValue"
      @click="updateValue"
    >
      <span class="sr-only">{{ t('SWITCH.TOGGLE') }}</span>
      <span
        class="absolute top-1/2 -translate-y-1/2 transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)]"
        :class="modelValue ? 'left-[16px]' : 'left-[2px]'"
      >
        <span
          class="block h-[14px] w-[14px] rounded-full bg-n-background shadow-md"
        />
      </span>
    </button>
    <div v-if="label || description" class="flex flex-col">
      <span v-if="label" class="text-sm font-medium text-n-text dark:text-n-text-white">{{ label }}</span>
      <span v-if="description" class="text-xs text-n-text-light dark:text-n-text-muted">{{ description }}</span>
    </div>
  </div>
</template>
